function dispatchUpdate() {
  document.dispatchEvent(
    new CustomEvent("juo-box:updated:state", {
      detail:
        window.juoBoxCart && window.juoBoxCart.getSubtotal
          ? window.juoBoxCart.getSubtotal()
          : { subtotal: 0, compareToPrice: 0, savings: 0 },
    })
  );
}

function createProducts(boxData) {
  const products = boxData.products.flatMap((product) =>
    product.variants.map((variant) => {
      var _a;
      return {
        productId: String(product.id),
        variantId: String(variant.id),
        imageURL:
          ((_a = product.media.at(0)) == null
            ? void 0
            : _a.preview_image.src) ?? "",
        title: product.title,
        variantTitle: variant.title,
        price: variant.price,
        sellingPlanAllocations: variant.selling_plan_allocations,
      };
    })
  );
  function addProduct(product) {
    products.push(product);
  }
  return {
    data: products,
    addProduct,
  };
}

function createBoxCart(boxData, allProducts, tiers, sellingPlans) {
  const BOX_CART_STATE_KEY = "juo-box-products";
  const state = {
    products: [],
    cartLinesToAdd: /* @__PURE__ */ new Map(),
    cartLinesToRemove: [],
    // This is populated by existing bundle products in cart
    parentProduct: null,
  };
  class CartError extends Error {}
  function init() {
    state.parentProduct = boxData.product;
    loadState();
  }
  function saveState() {
    if (localStorage != null) {
      localStorage.setItem(BOX_CART_STATE_KEY, JSON.stringify(state.products));
    }
  }
  function loadState() {
    if (window.Shopify == null) {
      return;
    }
    fetch(window.Shopify.routes.root + "cart.json", { cache: "no-store" })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return null;
        }
      })
      .then((cart) => {
        const items = [];
        if (cart != null) {
          cart.items.forEach((item) => {
            if ("_parent_product_id" in item.properties) {
              items.push({
                variantId: String(item.variant_id),
                quantity: item.quantity,
                imageURL: item.featured_image.url,
              });
            }
            state.cartLinesToRemove.push(item);
          });
        }
        if (items.length === 0 && localStorage != null) {
          const boxState = localStorage.getItem(BOX_CART_STATE_KEY);
          if (boxState != null) {
            items.push(
              ...JSON.parse(boxState).map((item) => ({
                ...item,
                quantity: 1,
              }))
            );
          }
        }
        items.map((item) => {
          for (let i = 0; i < item.quantity; i++) {
            state.products.push({ ...item, quantity: 1 });
          }
        });
        updateCartLinesToAdd();
        document.dispatchEvent(
          new CustomEvent("juo-box:updated:state", {
            detail: getSubtotal(),
          })
        );
      });
  }
  function clearState() {
    if (localStorage != null) {
      localStorage.removeItem(BOX_CART_STATE_KEY);
    }
  }
  function getProductSellingPlan(product, sellingPlanId, boxData) {
    if (!product || !product.sellingPlanAllocations) {
      return null;
    }
    
    // Najpierw spróbuj znaleźć po ID (dla normalnych przypadków)
    let allocation = product.sellingPlanAllocations.find(
      (allocation) =>
        String(allocation.selling_plan_id) === String(sellingPlanId)
    );
    
    // Jeśli nie znaleziono i używamy boxData.sellingPlans (build-a-box z 8%),
    // znajdź odpowiedni plan produktu (20%) na podstawie nazwy
    if (!allocation && boxData && boxData.sellingPlans) {
      const selectedBoxPlan = boxData.sellingPlans.find(
        p => String(p.id) === String(sellingPlanId)
      );
      
      if (selectedBoxPlan && selectedBoxPlan.name) {
        // Wyciągnij częstotliwość z nazwy (np. "30 days", "60 days", "90 days")
        const frequency = selectedBoxPlan.name.match(/(\d+)\s*(day|month)/i);
        
        if (frequency) {
          // Znajdź w allSellingPlans produktu plan o takiej samej częstotliwości
          const allPlansSource = [
            ...(boxData.allSellingPlans || []),
          ];
          
          const matchingPlan = allPlansSource.find(p => {
            return p.name && p.name.match(new RegExp(frequency[0], 'i'));
          });
          
          if (matchingPlan) {
            // Znajdź allocation dla tego planu
            allocation = product.sellingPlanAllocations.find(
              (allocation) =>
                String(allocation.selling_plan_id) === String(matchingPlan.id)
            );
          }
        }
      }
    }
    
    return allocation || null;
  }
  function getSubtotal() {
    let totalPrice = 0;
    let compareToPrice = 0;
    let savings = 0;
    const sellingPlanId = sellingPlans.sellingPlan();
    const priceOnJuoWidget = document.querySelector("p.j-price > .money");
    const isSubscribed = Boolean(sellingPlanId);
    const extraProductPrice = document.querySelector(
      ".juo-extra-product__price"
    );
    const extraProductPriceValue = extraProductPrice
      ? extraProductPrice.textContent
      : 0;
    const extraProductPriceValueFloat = parseFloat(extraProductPriceValue);
    const freeProductsValue =
      boxData.freeProduct.price != null &&
      isSubscribed &&
      state.products.length >= boxData.freeProductFrom
        ? boxData.freeProduct.price
        : 0;
    const tier = tiers.tier(state.products.length);
    state.products.map((boxProduct) => {
      const product = allProducts.find(
        ({ variantId }) => variantId === boxProduct.variantId
      );
      if (product == null) {
        console.error("Product not found");
        return;
      }
      const productSellingPlan =
        sellingPlanId != null
          ? getProductSellingPlan(product, sellingPlanId, boxData)
          : null;
      const productPrice =
        productSellingPlan != null ? productSellingPlan.price : product.price;
      const tierValue = tier != null ? tier.value : 0;
      
      // Cena finalna (z multipack i subskrypcją jeśli zaznaczona)
      totalPrice += Number.parseFloat(
        (((100 - tierValue) / 100) * productPrice).toFixed(2)
      );
      
      // Compare price: jeśli jest subskrypcja, użyj ceny z multipack (bez subskrypcji)
      // jeśli nie ma subskrypcji, użyj oryginalnej ceny
      const priceForCompare = isSubscribed 
        ? Number.parseFloat((((100 - tierValue) / 100) * product.price).toFixed(2))
        : product.price;
      compareToPrice += priceForCompare;
    }, 0);
    compareToPrice += freeProductsValue;
    const extraCheckbox = document.querySelector(
      ".juo-extra-product__checkbox"
    );
    const extraPriceEl = document.querySelector(".juo-extra-product__price");
    if (extraCheckbox && extraCheckbox.checked && extraPriceEl) {
      let extraPriceRaw = extraPriceEl.textContent;
      let extraPrice = extraPriceRaw
        .replace(/[^0-9,.-]+/g, "")
        .replace(",", ".");
      extraPrice = parseFloat(extraPrice);
      if (!isNaN(extraPrice)) {
        totalPrice += extraPrice * 100;
        compareToPrice += extraPrice * 100;
      }
      updateWidgetPrice();
    }
    savings = compareToPrice - totalPrice;
    if (priceOnJuoWidget) {
      priceOnJuoWidget.textContent = (totalPrice / 100).toFixed(2);
    }
    return {
      subtotal: totalPrice,
      compareToPrice,
      savings,
    };
  }
  async function addToCart() {
    if (window.Shopify == null) {
      return;
    }
    const { products, cartLinesToAdd, parentProduct } = state;
    const subtotal = getSubtotal();
    const { freeProduct } = boxData;
    // ID selling plany bierzemy z hidden inputa w natywnym formularzu produktu,
    // dokładnie tak jak oczekuje Shopify (ten input jest synchronizowany z przełącznikiem + selectem)
    const sellingPlanInput = document.querySelector(
      'form.product-form input[name="selling_plan"]'
    );
    const sellingPlanId =
      sellingPlanInput && sellingPlanInput.value
        ? sellingPlanInput.value
        : null;
    const cartItems = Array.from(cartLinesToAdd.values()).flatMap(
      ({ variantId, quantity }) => {
        const product = allProducts.find(
          ({ variantId: id }) => id === variantId
        );
        const productSellingPlan =
          sellingPlanId != null && product != null
            ? getProductSellingPlan(product, sellingPlanId, boxData)
            : null;

        // Użyj ID planu produktu (20%) zamiast ID planu box (8%)
        const productSellingPlanId = productSellingPlan 
          ? productSellingPlan.selling_plan_id 
          : null;

        const item = {
          id: parseInt(variantId, 10),
          quantity,
          properties: {
            _box: `box-${parentProduct == null ? void 0 : parentProduct.id}`,
            _parent_product_handle: `${
              parentProduct == null ? void 0 : parentProduct.handle
            }`,
            _parent_product_id: `${
              parentProduct == null ? void 0 : parentProduct.id
            }`,
          },
          ...(productSellingPlanId ? { selling_plan: productSellingPlanId } : {}),
        };
        return [item];
      }
    );
    // Dodaj extra produkt jeśli checkbox zaznaczony
    const extraCheckbox = document.querySelector(
      ".juo-extra-product__checkbox"
    );
    if (extraCheckbox && extraCheckbox.checked) {
      const selectedVariant = document.querySelector(
        'input[name="juo_extra_variant"]:checked'
      );
      if (selectedVariant) {
        cartItems.push({
          id: parseInt(selectedVariant.value, 10),
          quantity: 1,
          // extra produkt dodajemy jako one-time, żeby nie blokował subskrypcji boxa
        });
      }
    }
    const freeToCart =
      sellingPlanId != null &&
      products.length >= boxData.freeProductFrom &&
      freeProduct.id != null
        ? [
            {
              id: freeProduct.id,
              quantity: 1,
              properties: {
                _box: `box-${parentProduct.id}`,
                _parent_product_handle: `${parentProduct.handle}`,
              },
            },
          ]
        : [];
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          [`_box-${parentProduct == null ? void 0 : parentProduct.id}-savings`]:
            subtotal.savings,
        },
        items: [...cartItems, ...freeToCart],
      }),
    })
      .then(async (response) => {
        if (response.status !== 200) {
          if (response.status >= 200 && response.status < 500) {
            const responseData = await response.json();
            if ("description" in responseData) {
              throw new CartError(responseData.description);
            }
          }
          throw new Error("Unexpected response status: " + response.status);
        }
        clearState();
        document.dispatchEvent(new CustomEvent("juo-box:cart:added"));
        document.dispatchEvent(new Event("reload-side-cart"));
      })
      .finally(() => {
        // Wait for cart drawer to update, then open it
        setTimeout(() => {
          const cartDrawer = document.querySelector("#CartDrawer");
          if (cartDrawer) {
            cartDrawer.classList.remove("is-pre-empty");
          }
          const cartButton = document.querySelector(
            'button[data-sidebar-button][data-sidebar-id="CartDrawer"]'
          );
          if (cartButton) {
            cartButton.click();
          }
        }, 500);
      });
  }

  function dispatchBoxUpdatedEvent() {
    document.dispatchEvent(
      new CustomEvent("juo-box:updated:state", {
        detail: getSubtotal(),
      })
    );
  }

  function updateCartLinesToAdd() {
    const { products, cartLinesToAdd } = state;
    cartLinesToAdd.clear();
    products.map(({ variantId }) => {
      const currentItem = cartLinesToAdd.get(variantId);
      if (currentItem != null) {
        cartLinesToAdd.set(variantId, {
          ...currentItem,
          quantity: products.filter(
            (product) => product.variantId === variantId
          ).length,
          //we store each item separately
        });
        return;
      }
      cartLinesToAdd.set(variantId, {
        variantId,
        quantity: products.filter((product) => product.variantId === variantId)
          .length,
        //we store each item separately
      });
    });
  }
  function totalQtyForVariant(variantId) {
    var _a;
    return (_a = state.cartLinesToAdd.get(variantId)) == null
      ? void 0
      : _a.quantity;
  }
  init();
  return {
    addProduct(variantId) {
      const product = allProducts.find(
        (product2) => product2.variantId === variantId
      );
      if (product == null) {
        console.error("Product not found");
        return;
      }
      state.products.push({
        variantId: product.variantId,
        imageURL: product.imageURL,
        quantity: 1,
      });
      updateCartLinesToAdd();
      saveState();
      dispatchBoxUpdatedEvent();
    },
    removeProduct(variantId) {
      let lastIndex = state.products.length - 1;
      for (let i = lastIndex; i >= 0; i--) {
        if (state.products[i].variantId === variantId) {
          lastIndex = i;
        }
      }
      state.products.splice(lastIndex, 1);
      updateCartLinesToAdd();
      saveState();
      dispatchBoxUpdatedEvent();
    },
    products() {
      return state.products;
    },
    totalQtyForVariant,
    addToCart,
    dispatchBoxUpdatedEvent,
    getSubtotal: getSubtotal,
  };
}
function createBoxData() {
  const dataElement = document.getElementById("juo-box-data");
  if (dataElement == null) {
    console.warn("juo-box-data element not found");
    return;
  }
  const data = (function () {
    const parsed = JSON.parse(dataElement.innerText);
    const prices = {};
    parsed.ids.map((variantId) => {
      const foundVariant = parsed.variants.find(
        (variant) => variant.id == variantId
      );
      if (foundVariant != null) {
        prices[variantId] = foundVariant.price;
      }
    });
    const allSellingPlans = parsed.allSellingPlans
      .flatMap((group) => {
        if (Array.isArray(group)) {
          return group.flatMap((plan) => (Array.isArray(plan) ? plan : [plan]));
        }
        return [];
      })
      .filter((v, i, a) => a.findIndex((v2) => v2.id === v.id) === i);
    const variants = parsed.variants.map((variant) => {
      return {
        ...variant,
        selling_plan_allocations: variant.selling_plan_allocations.map(
          (allocation) => {
            const foundSellingPlan = allSellingPlans.find(
              (plan) => plan.id === allocation.selling_plan_id
            );
            return {
              ...allocation,
              name: foundSellingPlan != null ? foundSellingPlan.name : "",
            };
          }
        ),
      };
    });
    return {
      ids: parsed.ids,
      tiers: parsed.tiers,
      sellingPlans: parsed.sellingPlans,
      allSellingPlans,
      product: parsed.product,
      freeProduct: parsed.freeProduct,
      products: parsed.products,
      variants,
      minItemsCount: parsed.minItemsCount,
      freeProductFrom: parsed.freeProductFrom,
      prices,
    };
  })();
  return {
    data,
  };
}
function createTiers(tiers) {
  const sorted = tiers.sort((a, b) => a.productsCount - b.productsCount) ?? [];
  const lastTier = () => {
    const [last] = sorted.slice(-1) ?? [];
    return last;
  };
  const tierIndex = (quantity) => {
    if (lastTier() && quantity >= lastTier().productsCount) {
      return sorted.length - 1;
    }
    return sorted.findIndex((tier2) => tier2.productsCount > quantity) - 1;
  };
  const tier = (quantity) => {
    return tierIndex(quantity) >= 0 ? sorted[tierIndex(quantity)] : null;
  };
  const nextTier = (quantity) => sorted[tierIndex(quantity) + 1];
  const hasLastTier = (quantity) => {
    const [last] = sorted.slice(-1) ?? [];
    if (last) {
      return last.productsCount <= quantity.value;
    }
    return false;
  };
  const tiersMaxProducts = tiers.reduce(function (max, tier2) {
    return Math.max(max, tier2.productsCount);
  }, 0);
  const countToNextTier = (quantity) => {
    if (nextTier(quantity)) {
      return nextTier(quantity).productsCount - quantity;
    }
    return null;
  };
  return {
    tiers: sorted,
    tier,
    nextTier,
    lastTier,
    hasLastTier,
    countToNextTier,
    tiersMaxProducts,
  };
}
const selectors = {
  progressBar: ".progress-bar",
  progressBarWrapper: ".progress-bar--items",
  progressBarItem: ".progress-bar--item",
  progressBarLine: ".progress-line__active",
  removeBtn: ".button__remove",
  messageInitial: ".tiers-description--initial",
  messageInitialLeft: ".tiers-description--left",
  messageInitiallabel: ".tiers-description--label",
  messageInitialDiscount: ".tiers-description--discount",
  messageCompleted: ".tiers-description--completed",
};
function updateDrawerMessage(tiers, products) {
  const totalQty = products.length;
  const nextTier = tiers.nextTier(totalQty);
  const tiersDescriptionInitial = document.querySelector(
    selectors.messageInitial
  );
  const tiersDescriptionCompleted = document.querySelector(
    selectors.messageCompleted
  );
  if (nextTier != null && tiersDescriptionInitial != null) {
    const leftEl = tiersDescriptionInitial.querySelector(
      selectors.messageInitialLeft
    );
    if (leftEl != null) {
      leftEl.textContent = String(nextTier.productsCount - totalQty);
    }
    const discountEl = tiersDescriptionInitial.querySelector(
      selectors.messageInitialDiscount
    );
    if (discountEl != null) {
      discountEl.textContent = String(nextTier.value);
    }
    const label = tiersDescriptionInitial.querySelector(
      selectors.messageInitiallabel
    );
    if (label != null) {
      label.textContent =
        (nextTier.productsCount - totalQty > 1
          ? tiersDescriptionInitial.dataset.pluralLabel
          : tiersDescriptionInitial.dataset.singularLabel) ?? "product(s)";
    }
  }
  if (tiersDescriptionCompleted != null) {
    tiersDescriptionCompleted.style.display =
      nextTier == null ? "block" : "none";
  }
  if (tiersDescriptionInitial != null) {
    tiersDescriptionInitial.style.display = nextTier == null ? "none" : "block";
  }
}
function updateProgressLine(progressBarWrapper, totalQty) {
  let progressWidth = 0;
  const activeEls = progressBarWrapper.querySelectorAll(
    `${selectors.progressBarItem}.active`
  );
  activeEls.forEach((item) => {
    progressWidth +=
      item.offsetWidth + parseInt(window.getComputedStyle(item).marginRight);
  });
  const progressLine = document.querySelector(selectors.progressBarLine);
  if (progressLine != null) {
    progressLine.style.width = `${progressWidth}px`;
  }
  if (activeEls != null) {
    const activeItem = document.querySelector(
      `${selectors.progressBarItem}.active`
    );
    const figure = document.querySelector(
      `${selectors.progressBarItem}.active figure`
    );
    const progressBar = document.querySelector(selectors.progressBar);
    if (activeItem == null || figure == null || progressBar == null) {
      return;
    }
    const scrollPos =
      (totalQty - 1) *
        (figure.offsetWidth +
          parseInt(window.getComputedStyle(activeItem).marginRight)) -
      progressBar.offsetWidth;
    progressBar.scrollLeft = scrollPos;
  }
}
function populateProgressBar(products) {
  const progressBarWrapper = document.querySelector(
    selectors.progressBarWrapper
  );
  if (progressBarWrapper == null) {
    return;
  }
  const slotsCount = progressBarWrapper.querySelectorAll(
    selectors.progressBarItem
  ).length;
  const filledItemsCount = products.length;
  if (filledItemsCount > slotsCount - 2) {
    const lastItem = progressBarWrapper.querySelector(
      `${selectors.progressBarItem}:last-child`
    );
    if (lastItem != null) {
      for (let i = 0; i < filledItemsCount - slotsCount + 2; i++) {
        const newSlot = lastItem.cloneNode(true);
        progressBarWrapper.appendChild(newSlot);
      }
    }
  }
  if (products.length > 0) {
    products.forEach((product, index2) => {
      progressBarWrapper
        .querySelectorAll(selectors.progressBarItem)
        .forEach((slot, slotIndex) => {
          const removeBtn = slot.querySelector("[data-remove-from-box]");
          if (index2 === slotIndex) {
            slot.classList.add("active");
            if (removeBtn != null) {
              removeBtn.dataset.variantId = product.variantId;
            }
            const currentImg = slot.querySelector("figure img");
            if (
              !(currentImg == null
                ? void 0
                : currentImg.src.includes(product.imageURL))
            ) {
              const imgEl = document.createElement("img");
              imgEl.src = product.imageURL;
              const figureEl = slot.querySelector("figure");
              if (figureEl != null) {
                figureEl.innerHTML = "";
                figureEl.append(imgEl);
              }
            }
          } else if (slotIndex >= products.length) {
            slot.classList.remove("active");
          }
        });
    });
  } else {
    const firstSlot = progressBarWrapper.querySelector(
      `${selectors.progressBarItem}:nth-child(2)`
    );
    firstSlot == null ? void 0 : firstSlot.classList.remove("active");
    const slotImg =
      firstSlot == null ? void 0 : firstSlot.querySelector("figure");
    if (slotImg != null) {
      slotImg.innerHTML = "";
    }
  }
  updateProgressLine(progressBarWrapper, products.length);
}
function updateProgressBar(rootEl, data, tiersStep) {
  function getTotalQty() {
    let qty = 0;
    rootEl.querySelectorAll('input[name^="qty["]').forEach(function (input) {
      qty += Number.parseInt(input.value, 10);
    });
    return qty;
  }
  const progressBar = rootEl.querySelector('[data-ref="progress-bar"]');
  const totalQty = getTotalQty();
  const steps = progressBar.querySelectorAll('[data-ref="step"]');
  progressBar.querySelector('[data-ref="bar"]').style.width =
    Math.max(0, Math.min(1, (totalQty - 1) * tiersStep)) * 100 + "%";
  steps.forEach(function (el, index2) {
    el.classList[index2 < totalQty ? "add" : "remove"]("active");
  });
  const tiersIcons = progressBar.querySelectorAll('[data-ref="icon"]');
  const tiersWithElements = data.tiers.map(function (tier, index2) {
    const obj = Object.assign({}, tier);
    obj.element = tiersIcons[index2];
    return obj;
  });
  tiersWithElements.forEach(function (item) {
    item.element.parentElement.classList[
      item.productsCount <= totalQty ? "add" : "remove"
    ]("active");
  });
}
function renderProgressBar(root, data, tiersMaxProducts, tiersStep) {
  const progressBar = root.querySelector('[data-ref="progress-bar"]');
  progressBar.innerHTML = [
    '<span data-ref="bar" class="bab__progress-bar-active-bar" style="width: 0%"></span>',
    ...data.tiers.map(function (tier) {
      return `<span class="bab__progress-bar-marker" style="left: ${
        (tier.productsCount - 1) * tiersStep * 100
      }%"><span class="bab__progress-bar-content"><span data-ref="icon" class="bab__progress-bar-icon">🎉</span>${tier.value}% <br class="bab__progress-bar-line-break"/>off</span></span>`;
    }),
    ...Object.keys([...Array(tiersMaxProducts)]).map(function (index2) {
      return `<span
          data-ref="step"
          class="
            bab__progress-bar-step
            ${
              data.tiers.findIndex(function (tier) {
                return tier.productsCount - 1 == parseInt(index2, 10);
              }) !== -1
                ? "bab__progress-bar-step--threshold"
                : ""
            }
          "
          style="left: ${parseInt(index2, 10) * tiersStep * 100}%"
        ></span>`;
    }),
  ].join("");
}
function formatCurrency(amount) {
  if (window.Shopify == null) {
    return amount;
  }

  const currency = window.Shopify.currency.active;

  const leadingSymbolCurrencies = [
    "USD", "CAD", "GBP", "EUR", "CHF", "JPY", "CNY",
  ];
  const isLeading = leadingSymbolCurrencies.includes(currency);

  // Używamy stałego języka, np. "en" dla uniwersalnego formatowania
  const neutralLocale = "en";

  const numberFormatter = new Intl.NumberFormat(neutralLocale, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formattedNumber = numberFormatter.format(amount);

  const tempFormatter = new Intl.NumberFormat(neutralLocale, {
    style: "currency",
    currency: currency,
    currencyDisplay: "narrowSymbol",
  });

  const tempFormatted = tempFormatter.format(0);
  const currencySymbol = tempFormatted.replace(/[0-9.,\s]/g, "").trim();

  return isLeading
    ? `${currencySymbol} ${formattedNumber}`
    : `${formattedNumber} ${currencySymbol}`;
}


function createSellingPlans(boxData, products, checkbox, select) {
  const isSimpleProduct =
    (!Array.isArray(boxData.ids) || boxData.ids.length === 0) &&
    (!Array.isArray(boxData.variants) || boxData.variants.length === 0) &&
    (!Array.isArray(boxData.products) || boxData.products.length === 0) &&
    Array.isArray(boxData.sellingPlans) &&
    boxData.sellingPlans.length > 0;

  if (isSimpleProduct) {
    const uniqueByKey = new Map();
    boxData.sellingPlans.forEach((plan) => {
      if (!plan || !plan.id || !plan.name) return;
      const trimmedName = String(plan.name).trim();
      if (!trimmedName) return;
      const adj = Array.isArray(plan.price_adjustments)
        ? plan.price_adjustments[0]
        : plan.price_adjustments;
      const discountValue =
        adj && (adj.value_type === "percentage" || adj.value_type === "fixed_amount")
          ? adj.value
          : null;
      const discountType =
        adj && (adj.value_type === "percentage" || adj.value_type === "fixed_amount")
          ? adj.value_type
          : null;
      const planKey = `${trimmedName}__${discountType || "none"}__${discountValue ?? "none"}`;
      if (!uniqueByKey.has(planKey)) {
        uniqueByKey.set(planKey, {
          id: String(plan.id),
          name: trimmedName,
          discountValue,
          discountType,
        });
      }
    });

    const availablePlans = Array.from(uniqueByKey.values());

    function sellingPlan() {
      if (checkbox == null || select == null) return null;
      if (!checkbox.checked) return null;
      return select.value || null; // ID planu z <option value="...">
    }

    return {
      productsSellingPlans: [],
      availablePlans,
      sellingPlan,
    };
  }

  // 2. TRYB BOXA – wspólny plan po selling_plan_allocations / allSellingPlans
  const eligibleProducts = products.filter((product) =>
    boxData.ids.includes(parseInt(product.variantId, 10))
  );

  const productPlanIdSets = eligibleProducts
    .map((product) => {
      const allocations = product.sellingPlanAllocations || [];
      if (!allocations.length) {
        return null;
      }
      const ids = allocations.map(
        (allocation) => allocation.selling_plan_id
      );
      return new Set(ids);
    })
    .filter(Boolean);

  if (!productPlanIdSets.length) {
    return {
      productsSellingPlans: [],
      availablePlans: [],
      sellingPlan() {
        return null;
      },
    };
  }

  const intersection = new Set(productPlanIdSets[0]);
  for (let i = 1; i < productPlanIdSets.length; i++) {
    for (const id of Array.from(intersection)) {
      if (!productPlanIdSets[i].has(id)) {
        intersection.delete(id);
      }
    }
  }

  const commonPlanIds = Array.from(intersection);

  const useBoxSellingPlans = boxData.sellingPlans && boxData.sellingPlans.length > 0;
  const plansToUse = useBoxSellingPlans ? boxData.sellingPlans : [];
  
  const allPlansSource = [
    ...(boxData.sellingPlans || []),
    ...(boxData.allSellingPlans || []),
  ];
  const availablePlans = (() => {
    const byKey = new Map();

    const idsToProcess = useBoxSellingPlans 
      ? plansToUse.map(p => String(p.id))
      : commonPlanIds;

    idsToProcess.forEach((id) => {
      const plan = allPlansSource.find((p) => String(p.id) === String(id));
      if (!plan) return;

      if (!useBoxSellingPlans) {
        if (plan.recurring_deliveries === false || plan.recurring_deliveries == null) {
          return;
        }
      }
      const trimmedName = String(plan.name || "").trim();
      if (!trimmedName) return;

      const adj = Array.isArray(plan.price_adjustments)
        ? plan.price_adjustments[0]
        : plan.price_adjustments;
      const discountValue =
        adj && (adj.value_type === "percentage" || adj.value_type === "fixed_amount")
          ? adj.value
          : null;
      const discountType =
        adj && (adj.value_type === "percentage" || adj.value_type === "fixed_amount")
          ? adj.value_type
          : null;
      const planKey = `${trimmedName}__${discountType || "none"}__${discountValue ?? "none"}`;
      if (!byKey.has(planKey)) {
        byKey.set(planKey, {
          id: String(plan.id),
          name: trimmedName,
          discountValue,
          discountType,
        });
      }
    });

    return Array.from(byKey.values());
  })();

  function sellingPlan() {
    if (checkbox == null || select == null) {
      return null;
    }
    if (!checkbox.checked) {
      return null;
    }
    return select.value || null;
  }

  return {
    productsSellingPlans: [],
    availablePlans,
    sellingPlan,
  };
}
function formatPLN(amount) {
  return amount.toLocaleString("pl-PL", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
function updateWidgetPrice() {
  setTimeout(() => {
    const totalPriceEl = document.querySelector('[data-ref="total-price"]');
    const labelOneTime = document.querySelector(".j-otp.j-option .j-label");
    const labelSubscription = document.querySelector(
      ".j-subscription.j-option .j-label"
    );
    const subDiscount =
      document.querySelector(".box-builder").dataset.subDiscount;
    const priceBeforeDiscount = document.querySelector(
      ".bab__summary-wrapper .bab__summary-total-price .price.price--compare"
    );

    if (totalPriceEl && labelOneTime) {
      labelOneTime.setAttribute("data-price", totalPriceEl.textContent.trim());

      let afterWrapper = labelOneTime.querySelector(".after-price-wrapper");
      if (!afterWrapper) {
        afterWrapper = document.createElement("span");
        afterWrapper.className = "after-price-wrapper";
        labelOneTime.appendChild(afterWrapper);
      }

      let after = afterWrapper.querySelector(".after-price");
      if (!after) {
        after = document.createElement("span");
        after.className = "after-price";
        afterWrapper.appendChild(after);
      }
      after.setAttribute("data-price", totalPriceEl.textContent.trim());
      after.textContent = totalPriceEl.textContent.trim();

      if (priceBeforeDiscount && priceBeforeDiscount.textContent.trim()) {
        let discountValue = afterWrapper.querySelector(".one-time-discount");
        if (!discountValue) {
          discountValue = document.createElement("span");
          discountValue.className = "one-time-discount";
          afterWrapper.appendChild(discountValue);
        }

        let beforePrice = afterWrapper.querySelector(".before-price");
        if (!beforePrice) {
          beforePrice = document.createElement("span");
          beforePrice.className = "before-price";
          afterWrapper.appendChild(beforePrice);
        }
        beforePrice.textContent = priceBeforeDiscount.textContent.trim();

        const beforePriceNum = parseFloat(
          beforePrice.textContent.replace(/,/g, "").replace(/[^0-9.-]+/g, "")
        );
        const afterPriceNum = parseFloat(
          after.textContent.replace(/,/g, "").replace(/[^0-9.-]+/g, "")
        );
        const discountPercent = Math.round(
          (1 - afterPriceNum / beforePriceNum) * 100
        );
        discountValue.textContent = `-${discountPercent}%`;

        const pricesEqual =
          beforePrice.textContent.replace(/\s/g, "") ===
          after.textContent.replace(/\s/g, "");
        beforePrice.style.display = pricesEqual ? "none" : "flex";
        discountValue.style.display = pricesEqual ? "none" : "flex";
      }
    }

    if (subDiscount && labelSubscription) {
      let subPriceP = labelSubscription.querySelector(
        ".juo-subscription-price-duplicate"
      );
      const totalPrice = totalPriceEl ? totalPriceEl.textContent.trim() : "";
      const oneTimeLabel = document.querySelector(".j-otp.j-option .j-label");
      const oneTimePrice = oneTimeLabel
        ? oneTimeLabel.getAttribute("data-price")
        : "";
      const pricePerDayEl = document.querySelector(".price-per-day");
      const pricePerDay = pricePerDayEl ? pricePerDayEl.textContent.trim() : "";

      let discountedPrice = totalPrice;
      if (totalPrice && subDiscount) {
        // Parse totalPrice - handle both comma and dot as decimal separator
        // First replace comma with dot for decimal, then remove thousand separators and currency
        let priceStr = totalPrice
          .replace(/\.(?=\d{3})/g, '') // Remove dots that are thousand separators (followed by 3 digits)
          .replace(',', '.') // Replace comma with dot for decimal point
          .replace(/[^0-9.-]+/g, ''); // Remove currency symbols and other non-numeric chars
        const totalPriceNum = parseFloat(priceStr);
        const discountPercent = parseFloat(subDiscount);
        if (!isNaN(totalPriceNum) && !isNaN(discountPercent)) {
          discountedPrice = (
            totalPriceNum *
            (1 - discountPercent / 100)
          ).toFixed(2);
        }
      }

      function setComparePriceValue(attempt = 0) {
        let moneyStrike;
        if (subPriceP) {
          moneyStrike = subPriceP.querySelector(".j-compare-price .money");
        } else {
          moneyStrike = null;
        }
        if (moneyStrike) {
          moneyStrike.textContent = formatCurrency(
            parseFloat(oneTimePrice.replace(/,/g, "").replace(/[^0-9.-]+/g, ""))
          );
        } else if (attempt < 10) {
          setTimeout(() => setComparePriceValue(attempt + 1), 50);
        }
      }

      if (!subPriceP) {
        subPriceP = document.createElement("p");
        subPriceP.setAttribute("part", "price price--subscription");
        subPriceP.className = "j-price juo-subscription-price-duplicate";

        if (oneTimePrice) {
          const strike = document.createElement("span");
          strike.className = "j-compare-price";
          strike.setAttribute("part", "compare-price");
          const moneyStrike = document.createElement("span");
          moneyStrike.className = "money";
          moneyStrike.textContent = formatCurrency(
            parseFloat(oneTimePrice.replace(/,/g, "").replace(/[^0-9.-]+/g, ""))
          );
          strike.appendChild(moneyStrike);
          subPriceP.appendChild(strike);
        }

        const subSpan = document.createElement("span");
        subSpan.setAttribute("part", "subscription-price");
        const moneySub = document.createElement("span");
        moneySub.className = "money";
        moneySub.setAttribute("data-price", discountedPrice);
        moneySub.textContent = formatCurrency(parseFloat(discountedPrice));
        subSpan.appendChild(moneySub);
        subPriceP.appendChild(subSpan);

        if (pricePerDay) {
          const perDay = document.createElement("p");
          perDay.className = "price-per-day";
          perDay.textContent = pricePerDay;
          subPriceP.appendChild(perDay);
        }

        labelSubscription.appendChild(subPriceP);
        setComparePriceValue();
      } else {
        setComparePriceValue();
        const moneySub = subPriceP.querySelector(
          'span[part="subscription-price"] .money'
        );
        if (moneySub) {
          moneySub.setAttribute("data-price", discountedPrice);
          moneySub.textContent = formatCurrency(parseFloat(discountedPrice));
        }
        const perDay = subPriceP.querySelector(".price-per-day");
        if (perDay) perDay.textContent = pricePerDay;
      }
    }

  }, 150);
}
(function () {
  const selectors2 = {
    addToBox: "[data-add-to-box]",
    changeQty: "button[data-qty-target]",
    builderForm: ".box-builder__products-list",
    subscriptionCheckbox: "#juo-box-subscribe",
    subscriptionSelect: ".subscribe-box__select",
    productItem: ".box-builder__products-list--item",
    qtyInput: ".product-qty-input",
    removeBtn: ".button__remove",
    checkoutBtn: ".go-to-checkout",
    totalPrice: "[data-ref='total-price']",
    comparePrice: "[data-ref='compare-price']",
    savingsAmount: "[data-ref='savings']",
    drawer: ".box-builder__drawer",
  };
  function initBuilder() {
    const boxData = createBoxData();
    if (boxData == null) {
      return;
    }
    const subscriptionSelect = document.querySelector(
      selectors2.subscriptionSelect
    );
    const subscriptionCheckbox = document.querySelector(
      selectors2.subscriptionCheckbox
    );
    const products = createProducts(boxData.data);
    const tiers = createTiers(boxData.data.tiers);
  const sellingPlans = createSellingPlans(
    boxData.data,
    products.data,
    subscriptionCheckbox,
    subscriptionSelect
  );
    const boxCart = createBoxCart(
      boxData.data,
      products.data,
      tiers,
      sellingPlans
    );
    window.juoBoxCart = boxCart;

    const form = document.querySelector(selectors2.builderForm);
    if (form == null) {
      return;
    }

    form.addEventListener("click", onClick);
    form.querySelectorAll(selectors2.qtyInput).forEach((input) => {
      input.addEventListener("change", (e) => {
        if (e != null) {
          const qtyInput = e.target;
          const variantId = qtyInput.dataset.variant ?? "";
          const totalVariantQty = boxCart.totalQtyForVariant(variantId) ?? 0;
          const newValue = qtyInput.value === "" ? "0" : qtyInput.value;
          const change = Number.parseInt(newValue, 10) - totalVariantQty;
          if (change !== 0) {
            for (let i = 0; i < Math.abs(change); i++) {
              change > 0
                ? boxCart.addProduct(variantId)
                : boxCart.removeProduct(variantId);
            }
          }
        }
      });
    });
    document.addEventListener("click", (e) => {
      if (e == null) {
        return;
      }
      const buttonRemove = (e == null ? void 0 : e.target).matches(
        selectors2.removeBtn
      )
        ? e.target
        : null;
      if (buttonRemove != null) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        const variantId = buttonRemove.dataset.variantId;
        if (variantId != null && variantId !== "") {
          boxCart.removeProduct(variantId);
        }
      }
    });
    document.querySelectorAll(selectors2.productItem).forEach((productEl) => {
      const strengthEl = productEl.querySelector(".meta-item-strength");
      if (strengthEl == null) {
        return;
      }
      const metaValue = strengthEl == null ? void 0 : strengthEl.dataset.value;
      if (metaValue != null) {
        const matches = metaValue.match(/\d+/);
        const val = Number.parseInt(matches ? matches[0] : "0", 10);
        strengthEl.querySelectorAll("svg").forEach((el, index2) => {
          if (index2 < val) {
            el.classList.add("active");
          }
        });
      }
    });
    // Upewnij się, że natywny formularz produktu ma hidden input "selling_plan"
    const productForm = document.querySelector("form.product-form");
    let sellingPlanInput =
      productForm &&
      productForm.querySelector('input[name="selling_plan"]');
    if (productForm && !sellingPlanInput) {
      sellingPlanInput = document.createElement("input");
      sellingPlanInput.type = "hidden";
      sellingPlanInput.name = "selling_plan";
      productForm.appendChild(sellingPlanInput);
    }

    function syncSellingPlanInput() {
      if (!sellingPlanInput) return;
      if (
        subscriptionCheckbox &&
        subscriptionCheckbox.checked &&
        subscriptionSelect &&
        subscriptionSelect.value
      ) {
        sellingPlanInput.value = subscriptionSelect.value;
      } else {
        sellingPlanInput.value = "";
      }
    }

    if (subscriptionSelect != null) {
      if (
        sellingPlans.availablePlans &&
        sellingPlans.availablePlans.length > 0
      ) {
        sellingPlans.availablePlans.forEach((plan, index) => {
          const option = document.createElement("option");
          option.value = plan.id;
          if (plan.discountValue != null) {
            option.dataset.discountValue = plan.discountValue;
          }
          if (plan.discountType != null) {
            option.dataset.discountType = plan.discountType;
          }
          const discountLabel =
            plan.discountType === "percentage" && plan.discountValue
              ? ` (-${plan.discountValue}%)`
              : plan.discountType === "fixed_amount" && plan.discountValue
              ? ` (-${plan.discountValue})`
              : "";
          option.textContent = `${plan.name}${discountLabel}`;
          if (index === 0) {
            option.selected = true;
          }
          subscriptionSelect.append(option);
        });

        syncSellingPlanInput();

        subscriptionSelect.addEventListener("change", () => {
          syncSellingPlanInput();
          boxCart.dispatchBoxUpdatedEvent();
        });
      } else {
        console.warn(
          "No available selling plans found for subscription select. Available plans:",
          sellingPlans.availablePlans
        );
      }
    } else {
      console.warn(
        "Subscription select element (.subscribe-box__select) not found in DOM"
      );
      setTimeout(() => {
        const retrySelect = document.querySelector(
          selectors2.subscriptionSelect
        );
        if (
          retrySelect &&
          sellingPlans.availablePlans &&
          sellingPlans.availablePlans.length > 0
        ) {
          sellingPlans.availablePlans.forEach((plan, index) => {
            const option = document.createElement("option");
            option.value = plan.id;
            if (plan.discountValue != null) {
              option.dataset.discountValue = plan.discountValue;
            }
            if (plan.discountType != null) {
              option.dataset.discountType = plan.discountType;
            }
            const discountLabel =
              plan.discountType === "percentage" && plan.discountValue
                ? ` (-${plan.discountValue}%)`
                : plan.discountType === "fixed_amount" && plan.discountValue
                ? ` (-${plan.discountValue})`
                : "";
            option.textContent = `${plan.name}${discountLabel}`;
            if (index === 0) {
              option.selected = true;
            }
            retrySelect.append(option);
          });
          syncSellingPlanInput();
          retrySelect.addEventListener("change", () => {
            syncSellingPlanInput();
            boxCart.dispatchBoxUpdatedEvent();
          });
        }
      }, 100);
    }
    if (subscriptionCheckbox != null)
      subscriptionCheckbox.addEventListener("click", () => {
        if (subscriptionCheckbox.checked) {
          subscriptionSelect == null
            ? void 0
            : subscriptionSelect.classList.add("active");
        } else {
          subscriptionSelect == null
            ? void 0
            : subscriptionSelect.classList.remove("active");
        }
        syncSellingPlanInput();
        boxCart.dispatchBoxUpdatedEvent();
      });
    if (window.innerWidth < 768) {
      document.addEventListener("scroll", () => {
        const drawer = document.querySelector(selectors2.drawer);
        if (window.scrollY > 10) {
          drawer == null ? void 0 : drawer.classList.add("mobile-visible");
        } else {
          drawer == null ? void 0 : drawer.classList.remove("mobile-visible");
        }
      });
    }
    document.addEventListener("juo-box:updated:state", (e) => {
      updateView(e.detail);
    });

    function updateView(subtotalData) {
      const IN_CART_CLASS = "in-cart";
      const boxProducts = boxCart.products();
      document.querySelectorAll(selectors2.productItem).forEach((productEl) => {
        const elVariantId = productEl.dataset.variantId;
        if (elVariantId == null) {
          return;
        }
        const inCart = boxProducts.some(
          (product) => product.variantId === elVariantId
        );
        if (inCart) {
          productEl.classList.add(IN_CART_CLASS);
        } else {
          productEl.classList.remove(IN_CART_CLASS);
        }
        const totalVariantQty = boxCart.totalQtyForVariant(elVariantId) ?? 0;
        const qtyInput = productEl.querySelector(
          `[name="qty[${elVariantId}]"]`
        );
        if (qtyInput != null) {
          qtyInput.value = String(totalVariantQty);
        }
        if (totalVariantQty > 0) {
          const decreaseQtyBtn = productEl.querySelector(
            `[data-qty-target="qty[${elVariantId}]"][data-qty-add="-1"]`
          );
          decreaseQtyBtn.disabled = false;
        }
        if (totalVariantQty === 0) {
          const decreaseQtyBtn = productEl.querySelector(
            `[data-qty-target="qty[${elVariantId}]"][data-qty-add="-1"]`
          );
          decreaseQtyBtn.disabled = true;
        }
      });
      const checkoutBtn = document.querySelector(selectors2.checkoutBtn);
      const stickyBtn = document.querySelector("#sticky-atc-button");
      const buttons = [checkoutBtn, stickyBtn].filter(Boolean);
      
      if (boxData != null) {
        buttons.forEach((btn) => {
          if (boxProducts.length >= boxData.data.minItemsCount) {
            btn.disabled = false;
            btn.classList.remove("disabled");
          } else {
            btn.disabled = true;
            btn.classList.add("disabled");
          }
        });
      }
      checkoutBtn == null
        ? void 0
        : checkoutBtn.addEventListener("click", async (e) => {
            e.stopPropagation();
            e.stopImmediatePropagation();
            await boxCart.addToCart();
          });
      populateProgressBar(boxCart.products());
      renderProgressBar(
        form,
        boxData.data,
        tiers.tiersMaxProducts,
        1 / (tiers.tiersMaxProducts - 1)
      );
      updateDrawerMessage(tiers, boxCart.products());
      updateProgressBar(form, boxData.data, 1 / (tiers.tiersMaxProducts - 1));
      updateSummaryPrice(subtotalData);
      updateWidgetPrice();
    }

    function updateSummaryPrice(subtotalData) {
      const { subtotal, compareToPrice } = subtotalData;
      const totalPriceEl = document.querySelector(selectors2.totalPrice);
      const comparePriceEl = document.querySelector(selectors2.comparePrice);
      const savingsAmountEl = document.querySelector(selectors2.savingsAmount);
      if (comparePriceEl != null) {
        if (compareToPrice === 0 || compareToPrice === subtotal) {
          comparePriceEl.classList.add("hidden");
        } else {
          comparePriceEl.classList.remove("hidden");
        }
        comparePriceEl.textContent = formatCurrency(compareToPrice / 100);
      }
      if (totalPriceEl != null) {
        totalPriceEl.textContent = formatCurrency(subtotal / 100);
      }
      if (savingsAmountEl != null) {
        const savings = compareToPrice - subtotal;
        if (savings === 0) {
          savingsAmountEl.classList.add("hidden");
        } else {
          savingsAmountEl.classList.remove("hidden");
        }
        savingsAmountEl.textContent = formatCurrency(savings / 100);
      }
    }
    function getInputByButton(btn) {
      return form.querySelector(`input[name="${btn.dataset.qtyTarget}"]`);
    }
    function onClick(e) {
      if (e.target.matches(selectors2.changeQty)) {
        const input = getInputByButton(e.target);
        const variantId = e.target.dataset.qtyTarget.replace(
          /(qty\[)(\d+)\]/,
          "$2"
        );
        if (input.value == "") {
          input.value = "0";
        }
        const change = Number.parseInt(
          e.target.getAttribute("data-qty-add"),
          10
        );
        if (change > 0) {
          boxCart.addProduct(variantId);
        } else {
          boxCart.removeProduct(variantId);
        }
      }
      if (e.target.matches(selectors2.addToBox)) {
        e.preventDefault();
        const variantId = e.target.dataset.variantId;
        boxCart.addProduct(variantId);
      }
    }
    // Function to update main product price when a product is selected
    function updateSelectedProductPrice(variantId) {
      const mainPriceEl = document.querySelector('.product-price__current-price');
      if (!mainPriceEl || !variantId) return;

      // Find product price from products data
      const product = products.data.find(p => p.variantId === String(variantId));
      if (product && product.price) {
        // Price is stored in cents, convert to currency format
        const priceInCurrency = product.price / 100;
        mainPriceEl.textContent = formatCurrency(priceInCurrency);
      } else {
        // Fallback to boxData prices if product not found in products.data
        const priceFromBoxData = boxData.data.prices && boxData.data.prices[variantId];
        if (priceFromBoxData) {
          const priceInCurrency = priceFromBoxData / 100;
          mainPriceEl.textContent = formatCurrency(priceInCurrency);
        }
      }
    }

    // Function to switch product gallery images based on variant SKU (desktop only)
    function switchProductGalleryImages(variantSku) {
      // Only on desktop
      if (window.innerWidth < 768) return;
      
      if (!variantSku) return;

      // Find thumbnail carousel container
      const thumbnailCarousel = document.querySelector('.product-thumbnail-carousel__container[data-container="dots"]');
      if (!thumbnailCarousel) return;

      // Find thumbnail with matching SKU
      const matchingThumbnail = thumbnailCarousel.querySelector(`.product-thumbnail-carousel__thumb[data-sku="${variantSku}"]`);
      
      if (matchingThumbnail) {
        // Find all thumbnails
        const allThumbnails = thumbnailCarousel.querySelectorAll('.product-thumbnail-carousel__thumb');
        
        // Remove selection classes from all thumbnails
        allThumbnails.forEach((thumb) => {
          thumb.classList.remove('is-selected', 'is-primary');
        });

        // Add selection classes to matching thumbnail
        matchingThumbnail.classList.add('is-selected', 'is-primary');

        // Click the thumbnail to switch main image (triggers carousel navigation)
        setTimeout(() => {
          matchingThumbnail.click();
          
          // Scroll thumbnail into view if needed
          matchingThumbnail.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'nearest', 
            inline: 'center' 
          });
        }, 50);
      }
    }

    document
      .querySelectorAll(".box-builder__products-list--item")
      .forEach((item) => {
        item.addEventListener("click", function (e) {
          document
            .querySelectorAll(".box-builder__products-list--item")
            .forEach((el) => {
              el.classList.remove("active");
            });
          this.classList.add("active");

          const allItems = document.querySelectorAll(
            ".box-builder__products-list--item"
          );
          const allDescriptions = document.querySelectorAll(
            ".variant-short-description"
          );
          const clickedIndex = Array.from(allItems).indexOf(this);

          allDescriptions.forEach((desc) => {
            desc.style.display = "none";
          });

          if (
            this.classList.contains("active") &&
            allDescriptions[clickedIndex]
          ) {
            allDescriptions[clickedIndex].style.display = "flex";
          }

          const mediaBox = document.querySelector(".additional_box_media");
          const img = this.querySelector(".bab__product-image img");
          if (mediaBox && img) {
            mediaBox.innerHTML = `<img src="${img.src}" alt="" style="height:280px;width:100%;object-fit:cover;aspect-ratio:16/9;display:block;" />`;
          }

          // Update main product price when product is selected
          const variantId = this.dataset.variantId;
          if (variantId) {
            updateSelectedProductPrice(variantId);
          }

          // Switch product gallery images based on variant SKU (desktop only)
          const variantSku = this.dataset.variantSku;
          if (variantSku) {
            switchProductGalleryImages(variantSku);
          }
        });
      });

    // Set initial price and gallery images for first active product
    const firstActiveProduct = document.querySelector(".box-builder__products-list--item.active") || 
                                document.querySelector(".box-builder__products-list--item");
    if (firstActiveProduct) {
      const variantId = firstActiveProduct.dataset.variantId;
      if (variantId) {
        updateSelectedProductPrice(variantId);
      }
      
      const variantSku = firstActiveProduct.dataset.variantSku;
      if (variantSku) {
        switchProductGalleryImages(variantSku);
      }
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBuilder);
  } else {
    initBuilder();
  }
})();

function updateJuoWidgetPrice(subtotal) {
  const priceOnJuoWidget = document.querySelector("p.j-price > .money");
  if (subtotal !== null && priceOnJuoWidget) {
    priceOnJuoWidget.textContent = formatCurrency(subtotal / 100);
  }
}

document.addEventListener("juo-box:updated:state", function (e) {
  const subtotal = e.detail && e.detail.subtotal ? e.detail.subtotal : null;
  const totalPriceEl = document.querySelector('[data-ref="total-price"]');
  if (subtotal !== null && totalPriceEl) {
    totalPriceEl.textContent = formatCurrency(subtotal / 100);
  }
  updateJuoWidgetPrice(subtotal);
});

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("change", function (e) {
    if (e.target.matches('input[name="juo_extra_variant"]')) {
      const priceBox = document.getElementById("juo-extra-product-price");
      if (priceBox) priceBox.textContent = e.target.getAttribute("data-price");
      dispatchUpdate();
    }
    if (e.target.matches(".juo-extra-product__checkbox")) {
      const selectedVariant = document.querySelector(
        'input[name="juo_extra_variant"]:checked'
      );
      const priceBox = document.getElementById("juo-extra-product-price");
      if (selectedVariant && priceBox) {
        priceBox.textContent = selectedVariant.getAttribute("data-price");
      }
      dispatchUpdate();
      updateWidgetPrice();
    }
  });
  updateWidgetPrice();
});

document.addEventListener("DOMContentLoaded", function () {
  const mediaContainer = document.querySelector(
    "[data-product-media-container]"
  );
  const productMediaCarousel = document.querySelector(
    ".product-media-carousel"
  );
  const additionalBoxMedia = document.querySelector(".additional_box_media");
  const wrapper = document.querySelector(".element-wrapper");

  const productItems = document.querySelectorAll(
    ".box-builder__products-list--item"
  );
  if (
    productItems.length > 0 &&
    !document.querySelector(".box-builder__products-list--item.active")
  ) {
    const firstItem = productItems[0];
    firstItem.classList.add("active");
    const img = firstItem.querySelector(".bab__product-image img");
    if (additionalBoxMedia && img) {
      additionalBoxMedia.innerHTML = `<img src="${img.src}" alt="" style="height:280px;width:100%;object-fit:cover;aspect-ratio:16/9;display:block;" />`;
    }
  }

  // Funkcja do obliczania wysokości wrappera na podstawie pozycji .box-builder__summary
  function calculateWrapperHeight() {
    if (!wrapper) return;
    
    const boxBuilderSummary = document.querySelector(".box-builder .box-builder__summary");
    if (!boxBuilderSummary) {
      return;
    }

    const wrapperRect = wrapper.getBoundingClientRect();
    const boxBuilderSummaryRect = boxBuilderSummary.getBoundingClientRect();
    
    // Obliczamy różnicę między początkiem wrappera a początkiem box-builder__summary
    const wrapperTop = wrapperRect.top + window.scrollY;
    const boxBuilderSummaryTop = boxBuilderSummaryRect.top + window.scrollY;
    
    const calculatedHeight = boxBuilderSummaryTop - wrapperTop;
    
    if (calculatedHeight > 0) {
      wrapper.style.height = `${calculatedHeight}px`;
    }
  }

  function handleScroll() {
    if (
      !mediaContainer ||
      !productMediaCarousel ||
      !additionalBoxMedia ||
      !wrapper
    )
      return;

    if (window.innerWidth < 768) {
      const rect = mediaContainer.getBoundingClientRect();

      if (rect.top <= 0) {
        productMediaCarousel.classList.add("hidden");
        additionalBoxMedia.classList.remove("hidden");
      } else {
        productMediaCarousel.classList.remove("hidden");
        additionalBoxMedia.classList.add("hidden");
      }

      const stickyStart = 253;
      const wrapperRect = wrapper.getBoundingClientRect();
      const stickyHeight = additionalBoxMedia.offsetHeight;
      const wrapperBottom =
        wrapperRect.top + window.scrollY + wrapperRect.height;
      const stickyBottom = window.scrollY + stickyHeight;

      if (window.scrollY >= stickyStart && stickyBottom < wrapperBottom) {
        additionalBoxMedia.classList.add("is-sticky");
        additionalBoxMedia.classList.remove("is-sticky-bottom");
      } else if (
        window.scrollY >= stickyStart &&
        stickyBottom >= wrapperBottom
      ) {
        additionalBoxMedia.classList.remove("is-sticky");
        additionalBoxMedia.classList.add("is-sticky-bottom");
      } else {
        const hadSticky = additionalBoxMedia.classList.contains("is-sticky");
        additionalBoxMedia.classList.remove("is-sticky", "is-sticky-bottom");
        additionalBoxMedia.classList.add("hidden");
      }
    } else {
      productMediaCarousel.classList.remove("hidden");
      const hadSticky = additionalBoxMedia.classList.contains("is-sticky");
      additionalBoxMedia.classList.remove(
        "hidden",
        "is-sticky",
        "is-sticky-bottom"
      );
    }
  }

  if (additionalBoxMedia) additionalBoxMedia.classList.add("hidden");

  // Oblicz wysokość wrappera przy inicjalizacji
  calculateWrapperHeight();
  
  // Przelicz wysokość przy zmianie rozmiaru okna
  let resizeTimeout;
  window.addEventListener("resize", function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(calculateWrapperHeight, 100);
  });

  window.addEventListener("scroll", handleScroll);
});

// NOTE: extra product handling for non-BAB pages lives in product-form-block.liquid
// (juo-build-a-box.js is only loaded on BAB product pages).
